import { StyleSheet, Dimensions, Platform, PixelRatio } from "react-native";
import { backgroundColor2 } from "../constants/Constants";
import { BRAND_COLORS, BACKGROUND_COLORS } from "./colors";
const pixelDensity = PixelRatio.get();
const { width, height } = Dimensions.get("window");
let heightWindow = height;
let widthWindow = width;
if (heightWindow > 600) {
  heightWindow = height / 5;
} else {
  heightWindow = height / 1.8;
}

export const styles = StyleSheet.create({
  /////control color//////
  backgrounOption: {
    backgroundColor: BRAND_COLORS.ACCENT,
    flex: 1,
    //maxHeight: "100%",
  },
  backgrounOptionDos: {
    flex: 1,
  },
  componentColor: {
    backgroundColor: backgroundColor2,
  },
  textColor: {
    color: "#F9F9F9",
  },
  //////////////////////
  container: {
    flex: 1,
    flexDirection: "column",
    alignItems: "center",
    width: "100%",
    overflow: "visible",
    //maxHeight: "100%",
    // marginTop: 0,
  },
  containerInfo: {
    flex: 1,
    flexDirection: "column",
    alignItems: "center",
    // width: "100%",
    overflow: "visible",
    //maxHeight: "100%",
    // marginTop: 0,
  },
  row: {
    flex: 1,
    flexDirection: "row",
    justifyContent: "space-around",
    width: "100%",
  },
  column: {
    // width: "40%",
    flex: 1,
    // margin: "2.6%",
    // height: "20vh",
  },

  lineCell: {
    flexDirection: "row",
    borderBottomWidth: 2,
    alignItems: "center",
    justifyContent: "center",
    padding: 10,
  },
  buttonRight: {
    flexDirection: "row",
  },
  buttonContainer: {
    flexDirection: "row",
    flexWrap: "wrap",
    justifyContent: "center",
    flex: 1,
  },
  button: {
    backgroundColor: "#68848d",
    borderRadius: 12,
    paddingVertical: 12,
    paddingHorizontal: 20,
    marginVertical: 10,
    marginHorizontal: 8,
    shadowColor: "#000",
    shadowOffset: { width: 0, height: 2 },
    shadowOpacity: 0.25,
    shadowRadius: 5,
    elevation: 8,
    width: "40vh",
  },
  buttonsInfo: {
    backgroundColor: "#68848d",
    borderRadius: 12,
    paddingHorizontal: 20,
    marginVertical: 10,
    marginHorizontal: 8,
    shadowColor: "#000",
    shadowOffset: { width: 0, height: 2 },
    shadowOpacity: 0.25,
    shadowRadius: 5,
    elevation: 8,
    marginTop: 30,
    width: "30vh",
    height: "12vh",
    justifyContent: "center",
    alignItems: "center",
  },

  InfoTextWorking: {
    fontSize: Platform.OS === "web" ? 18 : 13,
    textAlign: "center",
    fontWeight: "bold",
    paddingHorizontal: 10,
  },

  InfoTextStoneConfirm: {
    fontSize: 12,
    textAlign: "center",
  },

  boxInfoTextStoneConfirm: {
    backgroundColor: "#00FF99",
    borderRadius: 5,
    padding: 4,
    marginVertical: 4,
    alignItems: "center",
    marginHorizontal: 3,
    shadowColor: "#000",
    shadowOffset: {
      width: 0,
      height: 2,
    },
    shadowOpacity: 0.23,
    shadowRadius: 2.62,
    elevation: 4,
    transform: [{ perspective: 1000 }, { rotateX: "5deg" }],
  },
  boxInfoTextWorking: {
    backgroundColor: "#306f77",
    borderRadius: 5,
    paddingTop: 8,
    paddingLeft: 4,
    paddingRight: 4,
    marginLeft: 14,
    paddingBottom: 8,
    marginVertical: 8,
    //alignItems: "end",
    marginHorizontal: 8,
    shadowColor: "#000",
    shadowOffset: {
      width: 0,
      height: 2,
    },
    shadowOpacity: 0.23,
    shadowRadius: 2.62,
    elevation: 4,
    transform: [{ perspective: 1000 }, { rotateX: "5deg" }],
  },

  buttonStartEnd: {
    paddingTop: Platform.OS === "web" ? 10 : 7,
    paddingBottom: Platform.OS === "web" ? 10 : 7,
    paddingLeft: Platform.OS === "web" ? 3 : 1,
    paddingRight: Platform.OS === "web" ? 3 : 1,
    borderRadius: 5,
    backgroundColor: backgroundColor2,
    marginHorizontal: 5,
    width: Platform.OS === "web" ? "40%" : "25%",
    justifyContent: "center",
    alignItems: "center",
    shadowColor: "#000",
    shadowOffset: {
      width: 0,
      height: 2,
    },
    shadowOpacity: 0.23,
    shadowRadius: 2.62,
    elevation: 4,
    transform: [{ perspective: 1000 }, { rotateX: "5deg" }],
  },

  buttonDetalles: {
    marginTop: 5,
    borderRadius: 5,
    backgroundColor: BRAND_COLORS.ACCENT,
    marginHorizontal: 5,
    width: "20%",
    justifyContent: "center",
    alignItems: "center",
    shadowColor: "#000",
    shadowOffset: {
      width: 0,
      height: 2,
    },
    shadowOpacity: 0.23,
    shadowRadius: 2.62,
    elevation: 4,
    transform: [{ perspective: 1000 }, { rotateX: "5deg" }],
  },

  buttonCerrarImgCalidad: {
    marginTop: 5,
    borderRadius: 5,
    backgroundColor: "#a1b9bf",
    marginHorizontal: 5,
    width: "20%",
    height: "10%",
    justifyContent: "center",
    alignItems: "center",
    shadowColor: "#000",
    shadowOffset: {
      width: 0,
      height: 2,
    },
    shadowOpacity: 0.23,
    shadowRadius: 2.62,
    elevation: 4,
    transform: [{ perspective: 1000 }, { rotateX: "5deg" }],
  },

  // buttonPreStartProcess: {
  //   paddingTop: Platform.OS === "web" ? 10 : 7,
  //   paddingBottom: Platform.OS === "web" ? 10 : 7,
  //   paddingLeft: Platform.OS === "web" ? 3 : 1,
  //   paddingRight: Platform.OS === "web" ? 3 : 1,
  //   borderRadius: 5,
  //   backgroundColor: "#FFA726",
  //   marginHorizontal: 5,
  //   width: Platform.OS === "web" ? "40%" : "30%",
  //   justifyContent: "center",
  //   alignItems: "center",
  //   shadowColor: "#000",
  //   shadowOffset: {
  //     width: 0,
  //     height: 2,
  //   },
  //   shadowOpacity: 0.23,
  //   shadowRadius: 2.62,
  //   elevation: 4,
  //   transform: [{ perspective: 1000 }, { rotateX: "5deg" }],
  // },
  buttonPreStartProcess: {
    paddingVertical: 5,
    paddingHorizontal: 10,
    borderRadius: 5,
    backgroundColor: "#FFA726",
    marginHorizontal: 2,
    width: 100,
    justifyContent: "center",
    alignItems: "center",
    shadowColor: "#000",
    shadowOffset: {
      width: 0,
      height: 1,
    },
    shadowOpacity: 0.23,
    shadowRadius: 2.62,
    elevation: 2,
    transform: [{ perspective: 1000 }, { rotateX: "5deg" }],
  },
  // buttonStartProcess: {
  //   paddingTop: Platform.OS === "web" ? 10 : 7,
  //   paddingBottom: Platform.OS === "web" ? 10 : 7,
  //   paddingLeft: Platform.OS === "web" ? 3 : 1,
  //   paddingRight: Platform.OS === "web" ? 3 : 1,
  //   borderRadius: 5,
  //   backgroundColor: "#00BFA5",
  //   marginHorizontal: 5,
  //   width: Platform.OS === "web" ? "40%" : "30%",
  //   justifyContent: "center",
  //   alignItems: "center",
  //   shadowColor: "#000",
  //   shadowOffset: {
  //     width: 0,
  //     height: 2,
  //   },
  //   shadowOpacity: 0.23,
  //   shadowRadius: 2.62,
  //   elevation: 4,
  //   transform: [{ perspective: 1000 }, { rotateX: "5deg" }],
  // },

  buttonStartProcess: {
    paddingVertical: 5,
    paddingHorizontal: 10,
    borderRadius: 5,
    backgroundColor: "#00BFA5",
    marginHorizontal: 2,
    width: 100,
    justifyContent: "center",
    alignItems: "center",
    shadowColor: "#000",
    shadowOffset: {
      width: 0,
      height: 1,
    },
    shadowOpacity: 0.23,
    shadowRadius: 2.62,
    elevation: 2,
    transform: [{ perspective: 1000 }, { rotateX: "5deg" }],
  },
  // buttonFinishProcess: {
  //   paddingTop: Platform.OS === "web" ? 10 : 7,
  //   paddingBottom: Platform.OS === "web" ? 10 : 7,
  //   paddingLeft: Platform.OS === "web" ? 3 : 1,
  //   paddingRight: Platform.OS === "web" ? 3 : 1,
  //   borderRadius: 5,
  //   backgroundColor: "red",
  //   marginHorizontal: 5,
  //   width: Platform.OS === "web" ? "40%" : "30%",
  //   justifyContent: "center",
  //   alignItems: "center",
  //   shadowColor: "#000",
  //   shadowOffset: {
  //     width: 0,
  //     height: 2,
  //   },
  //   shadowOpacity: 0.23,
  //   shadowRadius: 2.62,
  //   elevation: 4,
  //   transform: [{ perspective: 1000 }, { rotateX: "5deg" }],
  // },
  buttonFinishProcess: {
    paddingVertical: 5,
    paddingHorizontal: 10,
    borderRadius: 5,
    backgroundColor: "red",
    marginHorizontal: 2,
    width: 100,
    justifyContent: "center",
    alignItems: "center",
    shadowColor: "#000",
    shadowOffset: {
      width: 0,
      height: 1,
    },
    shadowOpacity: 0.23,
    shadowRadius: 2.62,
    elevation: 2,
    transform: [{ perspective: 1000 }, { rotateX: "5deg" }],
  },
  // buttonPreStopProcess: {
  //   paddingTop: Platform.OS === "web" ? 10 : 7,
  //   paddingBottom: Platform.OS === "web" ? 10 : 7,
  //   paddingLeft: Platform.OS === "web" ? 3 : 1,
  //   paddingRight: Platform.OS === "web" ? 3 : 1,
  //   borderRadius: 5,
  //   backgroundColor: "#999999",
  //   marginHorizontal: 5,
  //   width: Platform.OS === "web" ? "40%" : "30%",
  //   justifyContent: "center",
  //   alignItems: "center",
  //   shadowColor: "#000",
  //   shadowOffset: {
  //     width: 0,
  //     height: 2,
  //   },
  //   shadowOpacity: 0.23,
  //   shadowRadius: 2.62,
  //   elevation: 4,
  //   transform: [{ perspective: 1000 }, { rotateX: "5deg" }],
  // },
  buttonPreStopProcess: {
    paddingVertical: 5,
    paddingHorizontal: 10,
    borderRadius: 5,
    backgroundColor: "#999999",
    marginHorizontal: 2,
    width: 100,
    justifyContent: "center",
    alignItems: "center",
    shadowColor: "#000",
    shadowOffset: {
      width: 0,
      height: 1,
    },
    shadowOpacity: 0.23,
    shadowRadius: 2.62,
    elevation: 2,
    transform: [{ perspective: 1000 }, { rotateX: "5deg" }],
  },

  timerRowContainer: {
    flex: 1,
    flexDirection: "row",
    alignItems: "center", // Centra verticalmente
    justifyContent: "space-between", // Distribuye el espacio entre los botones
    // padding: 8,
  },
  buttonStartProcessCustom: {
    flex: 1,
    paddingVertical: 10,
    marginHorizontal: 5,
    backgroundColor: "#00BFA5",
    borderRadius: 5,
    justifyContent: "center",
    alignItems: "center",
  },
  buttonPreStartProcessCustom: {
    flex: 1,
    paddingVertical: 10,
    marginHorizontal: 5,
    backgroundColor: "#FFA726",
    borderRadius: 5,
    justifyContent: "center",
    alignItems: "center",
  },
  buttonFinishProcessCustom: {
    flex: 1,
    paddingVertical: 10,
    marginHorizontal: 5,
    backgroundColor: "red",
    borderRadius: 5,
    justifyContent: "center",
    alignItems: "center",
  },
  buttonPreStopProcessCustom: {
    flex: 1,
    paddingVertical: 10,
    marginHorizontal: 5,
    backgroundColor: "#999999",
    borderRadius: 5,
    justifyContent: "center",
    alignItems: "center",
  },
  timerCountCustom: {
    paddingVertical: 10,
    paddingHorizontal: 5,
    backgroundColor: "#A1B9BF",
    borderRadius: 5,
    marginHorizontal: 5,
    justifyContent: "center",
    alignItems: "center",
  },

  buttonTextCustom: {
    fontSize: 15,
    fontWeight: "bold",
    fontFamily: "monospace",
  },
  textColorCustom: {
    color: "white",
  },

  image: {
    height: "95%",
    // height: 200,
    resizeMode: "contain",
    backgroundColor: "white",
    borderRadius: 10,
    borderWidth: 1,
    marginTop: 5,
    padding: 10,
    paddingHorizontal: 20,
    marginVertical: 10,
    borderColor: "black",
  },
  infobox: {
    padding: 10,
    borderRadius: 12,
    paddingHorizontal: 20,
    marginVertical: 10,
    marginHorizontal: 8,
    shadowColor: "#000",
    shadowOffset: { width: 0, height: 2 },
    shadowOpacity: 0.25,
    shadowRadius: 5,
    elevation: 8,
    marginTop: 5,
  },
  infoText: {
    fontWeight: "bold",
    fontSize: 17,
    fontFamily: "monospace",
  },
  infoTextWhite: {
    fontWeight: "bold",
    fontSize: 17,
    color: "white",
    fontFamily: "monospace",
  },
  buttonText: {
    fontWeight: "bold",
    textAlign: "center",
    fontSize: Platform.OS === "web" ? 18 : 14,
    textAlignVertical: "center",
    justifyContent: "center",
    fontFamily: "monospace",
  },

  buttonTextCheckConfirmed: {
    fontFamily: "monospace",
    fontWeight: "bold",
    textAlign: "center",
    fontSize: Platform.OS === "web" ? 18 : 12,
    textAlignVertical: "center",
    justifyContent: "center",
  },

  lineTitle: {
    borderWidth: 2,
    borderColor: "#071907",
    paddingVertical: 10,
    alignItems: "center",
    marginBottom: 10,

    borderRadius: 8,
    shadowColor: "#000",
    shadowOffset: {
      width: 0,
      height: 2,
    },
    shadowOpacity: 0.3,
    shadowRadius: 3,
    elevation: 2,
  },

  textTitle: {
    fontSize: 17,
    alignItems: "center",
    fontWeight: "bold",
    fontFamily: "monospace",
  },
  textHeader: {
    fontSize: Platform.OS === "web" ? 17 : 12,
    fontFamily: "monospace",
    alignItems: "center",
    fontWeight: "bold",
    marginBottom: 10,
  },
  textList: {
    fontSize: Platform.OS === "web" ? 16 : 12,
    alignItems: "center",
    textAlign: "center",
    fontFamily: "monospace",
    //color: "green",
    padding: 1,
  },

  footerColumn: {
    flex: 1,
    marginRight: 10,
  },

  buttonDo: {
    flex: 1,
    borderRadius: 8,
    padding: 8,
    flexDirection: "row",
    alignItems: "center",
    shadowColor: "#000",
    shadowOffset: {
      width: 0,
      height: 2,
    },
    shadowOpacity: 0.23,
    shadowRadius: 2.62,
    elevation: 4,
  },
  nextStep: {
    flexDirection: "row",
    alignItems: "flex-end",
    justifyContent: "flex-end",
  },

  textNextStep: {
    fontSize: 16,
  },
  footer: {
    marginTop: 15,
  },
  celNextStep: {
    flex: 1,
    backgroundColor: "#A1B9BF",
    borderRadius: 8,
    padding: 8,
    flexDirection: "row",
    alignItems: "center",
    justifyContent: "center",
    shadowColor: "#000",
    shadowOffset: {
      width: 0,
      height: 2,
    },
    shadowOpacity: 0.23,
    shadowRadius: 2.62,
    elevation: 4,
  },

  time: {
    flexDirection: "row",
    borderBottomWidth: 1,
    width: "100%",
  },
  TimerCount: {
    paddingTop: 5,
    paddingBottom: 5,
    paddingLeft: 5,
    paddingRight: 5,
    borderRadius: 5,
    backgroundColor: "#A1B9BF",
    marginHorizontal: 2,
    justifyContent: "center",
    alignItems: "center",
    shadowColor: "#000",
    shadowOffset: {
      width: 0,
      height: 1,
    },
    shadowOpacity: 0.23,
    shadowRadius: 2.62,
    elevation: 2,
    transform: [{ perspective: 1000 }, { rotateX: "5deg" }],
    minWidth: 60,
  },

  //////login//////
  containerLogin: {
    flex: 1,
    justifyContent: "center",
    paddingHorizontal: 20,
    alignItems: "center",
  },

  contadorVersion: {
    fontFamily: "monospace",
    color: "gray",
    fontSize: 12,
    position: "absolute",
    top: 10,
    right: 10,
  },
  inputLogin: {
    width: 380,
    padding: 10,
    backgroundColor: "rgba(255, 255, 255, 0.85)",
    borderRadius: 15,
    alignItems: "center",
    shadowColor: "#000",
    shadowOffset: { width: 0, height: 2 },
    shadowOpacity: 0.25,
    shadowRadius: 5,
    elevation: 8,
    fontSize: 24,
  },
  textLogin: {
    color: "white",
    fontSize: 18,
    marginBottom: 5,
  },
  buttonLogin: {
    marginTop: 10,
    padding: 10,
    borderRadius: 5,
    backgroundColor: backgroundColor2,
    marginHorizontal: 5,
    width: "10%",
    justifyContent: "center",
    alignItems: "center",
    shadowColor: "#000",
    shadowOffset: {
      width: 0,
      height: 2,
    },
    shadowOpacity: 0.23,
    shadowRadius: 2.62,
    elevation: 4,
  },

  //////Scan////////
  containerScan: {
    flex: 1,
    justifyContent: "center",
    alignItems: "center",
  },

  barcode: {
    width: 300,
    height: 200,
    borderWidth: 2,
    borderColor: "black",
    marginBottom: 30,
  },
  barcodeBox: {
    alignItems: "center",
    justifyContent: "center",
    marginBottom: 20,
  },
  redLine: {
    width: 300,
    height: 4,
    backgroundColor: "red",
    opacity: 0.9, // Ajusta el valor de opacidad según tus preferencias (0.0 - 1.0)
    filter: "blur(2px)", // Ajusta el valor de difuminado según tus preferencias
    boxShadow: "0 0 8px 2px rgba(255, 139, 139, 0.5)", // Luz blanca alrededor de la línea
    shadowColor: "#000",
    shadowOffset: {
      width: 0,
      height: 2,
    },
    shadowOpacity: 0.25,
    shadowRadius: 3.84,
    elevation: 5,
  },
  ////// formComponent /////
  formCompStyle: {
    backgroundColor: "white",
    borderWidth: 1,
    borderColor: "gray",
    padding: 10,
    marginBottom: 10,
  },

  /////modal/////
  modalContainer: {
    flex: 1,
    backgroundColor: "rgba(69, 99, 105, 0.4)", // Verde oliva con transparencia (#456369)
    justifyContent: "center",
    alignItems: "center",
    paddingHorizontal: 20,
  },
  modalContent: {
    backgroundColor: "#223134", // Color de fondo #456369
    padding: 20,
    borderRadius: 10,
    marginHorizontal: 20, // Añade margen horizontal
    marginTop: 100,
    marginBottom: 200,
  },
  modalText: {
    fontSize: Platform.OS === "web" ? 18 : 14,
    color: "white",
    marginBottom: 8,
    textAlign: "center",
  },
  modalTextSub: {
    fontSize: 15,
    color: "white",
    marginBottom: 8,
    textAlign: "center",
  },

  buttonModalContainer: {
    flexDirection: "row",
    justifyContent: "space-around",
    marginTop: 10,
  },
  optionItem: {
    paddingVertical: 8,
    paddingHorizontal: 16,
    backgroundColor: "#E0E0E0",
    borderRadius: 4,
    marginBottom: 8,
  },
  optionText: {
    fontSize: 16,
    color: "black",
  },
  selectedOptionItem: {
    backgroundColor: "blue",
  },
  selectedOptionText: {
    color: "white",
  },
  checkconfirmed: {
    backgroundColor: "#505050",
    textColor: "white",
    borderRadius: 5,
    padding: 4,
    marginVertical: 4,
    alignItems: "center",
    //marginHorizontal: 5,
    shadowColor: "#000",
    shadowOffset: {
      width: 0,
      height: 2,
    },
    shadowOpacity: 0.23,
    shadowRadius: 2.62,
    elevation: 4,
    transform: [{ perspective: 1000 }, { rotateX: "5deg" }],
  },

  SelectOptionList: {
    flex: 1,
    padding: 4,
    borderRadius: 5,
    backgroundColor: backgroundColor2,
    marginHorizontal: 5,
    justifyContent: "center",
    alignItems: "center",
    shadowColor: "#000",
    shadowOffset: {
      width: 0,
      height: 2,
    },
    shadowOpacity: 0.23,
    shadowRadius: 2.62,
    elevation: 4,
    transform: [{ perspective: 1000 }, { rotateX: "5deg" }],
  },

  weightContainer: {
    flex: 1,
    marginHorizontal: 5,
  },

  WeightOptionText: {
    flex: 1,
    fontSize: 16,
    padding: 0,
    borderRadius: 5,
    backgroundColor: "rgba(213, 221, 213, 0.5)", // Utiliza el valor RGBA para establecer la transparencia
    justifyContent: "center",
    alignItems: "center",
    borderColor: "rgba(0, 0, 0, 0.5)",
    paddingHorizontal: 10,
    fontSize: 16,
    color: "black",
  },

  ButtonOptionList: {
    flex: 1,
    padding: 4,
    borderRadius: 5,
    backgroundColor: backgroundColor2,
    marginHorizontal: 5,
    justifyContent: "center",
    alignItems: "center",
    shadowColor: "#000",
    shadowOffset: {
      width: 0,
      height: 2,
    },
    shadowOpacity: 0.23,
    shadowRadius: 2.62,
    elevation: 4,
    transform: [{ perspective: 1000 }, { rotateX: "5deg" }],
  },

  buttonContent: {
    backgroundColor: "#68848d",
    borderRadius: 10,
    paddingVertical: 10,
    paddingHorizontal: 15,
    marginVertical: 10,
    marginHorizontal: 5,
    shadowColor: "#000",
    shadowOffset: { width: 0, height: 2 },
    shadowOpacity: 0.3,
    shadowRadius: 5,
    elevation: 8,
  },

  buttonDinamicStyle: {
    fontFamily: "monospace",
    color: "white",
    fontWeight: "bold",
    marginBottom: 8,
    fontSize: 18,
  },

  buttonContainerTres: {
    flexDirection: "row",
    alignItems: "center",
    borderRadius: 20,
    paddingVertical: 10,
    paddingHorizontal: 20,
    padding: 20,
    margin: 10,
    width: "35vh",
    height: "10vh",
  },
  iconContainerTres: {
    backgroundColor: "#FFFFFF",
    padding: 10,
    borderRadius: 50,
    marginRight: 10,
  },
  buttonTextTres: {
    color: "white",
    fontSize: 18,
    fontWeight: "bold",
    fontFamily: "monospace",
  },

  buttonScanMarcar: {
    backgroundColor: "#4CAF50",
    fontSize: 16,
    fontWeight: "bold",
    paddingVertical: 8,
    paddingHorizontal: 12,
    textAlign: "center",
    borderColor: "#00796B", // Color del borde
    borderRadius: 5,
    shadowColor: "#000",
    marginLeft: 5,
    shadowOffset: {
      width: 0,
      height: 2,
    },
    shadowOpacity: 0.23,
    shadowRadius: 2.62,
    elevation: 4,
  },

  incidenciaCheckbox: {
    width: 20,
  },
  incidenciaRow: {
    flexDirection: "row",
    alignItems: "center",
  },
  modalTextIncidencia: {
    fontSize: Platform.OS === "web" ? 18 : 14,
    color: "white",
    marginBottom: 8,
    textAlign: "center",
    marginRight: 8,
  },
  modalTextIncidenciaCheckBox: {
    borderRadius: 5,
    width: 20,
    height: 20,
    marginBottom: 5,
    textAlign: "center",
    marginLeft: 8,
  },

  /////// Quality / reception

  inputFinishedPieces: {
    fontSize: Platform.OS === "web" ? 18 : 14,
    color: "white",
    marginBottom: 8,
    textAlign: "center",
    backgroundColor: "black",
    borderRadius: 5,
    width: "60%",
    height: "100%",
    justifyContent: "center",
    alignItems: "center",
    shadowColor: "#000",
    shadowOffset: {
      width: 0,
      height: 2,
    },
    shadowOpacity: 0.23,
    shadowRadius: 2.62,
    elevation: 4,
    transform: [{ perspective: 1000 }, { rotateX: "5deg" }],
  },

  AccesoDirectosScan: {
    fontSize: 16,
    height: 40,
    padding: 8,
    backgroundColor: backgroundColor2,
    color: "white",
    margin: 5,
    borderRadius: 5,
    shadowColor: "rgba(0, 0, 0, 0.3)",
    flexWrap: "wrap",
    shadowOffset: {
      width: 0,
      height: 4, // Ajusta la altura de la sombra para mayor profundidad
    },
    shadowOpacity: 0.5, // Ajusta la opacidad de la sombra
    shadowRadius: 4, // Ajusta el radio de la sombra
    elevation: 8, // Efecto de elevación para di
  },

  modalContentWrapper: {
    backgroundColor: "#445b62",
    padding: 20,
    borderRadius: 20,
    shadowColor: "#000",
    shadowOffset: { width: 0, height: 2 },
    shadowOpacity: 0.25,
    shadowRadius: 4,
    elevation: 5,
    width: "35%", // Ajusta este valor según necesites
    maxHeight: "60%", // Limita la altura del modal
    display: "flex",
    flexDirection: "column",
    justifyContent: "space-between",
  },
  modalContainerStyle: {
    flex: 1,
    justifyContent: "center",
    alignItems: "center",
    backgroundColor: "rgba(0,0,0,0.5)", // Fondo semi-transparente
  },
  modalContentStyle: {
    flex: 1, // Permite que el contenido se desplace
  },

  modalButtonStyle: {
    padding: 10,
    backgroundColor: BRAND_COLORS.ACCENT,
    borderRadius: 5,
    alignItems: "center",
    marginVertical: 5,
    width: "20%",
  },
  modalButtonTextStyle: {
    color: "white",
    fontSize: 16,
  },

  processContainerStyle: {
    flexDirection: "row",
    justifyContent: "space-between",
    alignItems: "center",
    marginBottom: 10,
  },
  processTextStyle: {
    flex: 3, // Ajusta según necesites para dar más espacio al texto
    textAlign: "left",
    fontFamily: "monospace",
    color: "white",
    fontWeight: "bold",
    fontSize: "18",
  },
  processInputStyle: {
    flex: 2, // Ajusta según el espacio que quieras dar al input
    borderWidth: 1,
    borderColor: "#ccc",
    padding: 8,
    marginRight: 10,
    color: "white", // Esto hará que el texto escrito sea blanco
  },
  modalButtonContainer: {
    flexDirection: "row",
    justifyContent: "space-around",
    marginTop: 20,
  },
});
